import { RouteObject } from 'react-router-dom'
import { ShortagePage } from './shortage'

export const ShortageRoute: RouteObject = {
    path: '/shortage',
    element: <ShortagePage />,
}
